export const VERSION = {
  version: '0.94-7b8d122',
  buildDate: '2025-11-05 12:59:50'
};
